import { DataService } from './dataService'
export const locationServices = {
	addCountry: async (data) => {
		return DataService.post('/admin/add_country', data)
	},

	updateCountry: async (data) => {
		return DataService.post('/admin/update_country' ,data)
	},

    updateCountryStatus: async (data) => {
        return DataService.post('/admin/update_country_status' ,data)
    },

    addCity: async (data) => {
		return DataService.post('/admin/add_city', data)
	},

    updateCity: async (data) => {
		return DataService.post('/admin/update_city', data)
	},

	updateCityStatus: async (data) => {
		return DataService.post('/admin/update_city_status' ,data)
	},

    getCountry: async (data) => {
		return DataService.get('/admin/get_country', data)
		// return DataService.get('/admin/get_countries', data)
	},

	getCity: async (data) => {
		return DataService.get('/admin/get_city' ,data)
	},
	getCountryDetails: async (data) => {
		return DataService.get('/admin/get_country_detail', data)
	},

	getCityDetails: async (data) => {
		return DataService.get('/admin/get_city_detail' ,data)
	},
	deletePort: async (data) => {
		return DataService.post('/admin/delete_port' ,data)
	},
}

export default locationServices